var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTypeMissing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 165,
    height: 146,
    viewBox: "0 0 165 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80273 67.5234V69.024",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.43359 68.3359L4.65975 69.5982",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 71.6953H3.73377",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.29297 75.1138L4.51912 73.8516",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80273 75.524V74.0234",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.30505 74.5238L8.30469 73.5234",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3052 72.0234H9.80469",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.305 68.5234L9.30469 69.5238",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M87.334 2V3.00036",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M84.332 5.00781H85.3324",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.334 8.00817V7.00781",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8343 5.00781H88.834",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3125 44.0156V45.5162",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8105 48.5156H26.3111",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3125 52.524V51.0234",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.313 48.5156H31.8125",
    stroke: "#D2D8DF",
    strokeWidth: 2.921,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M136.979 98.5547C138.175 98.5547 139.144 99.5244 139.144 100.72C139.144 101.916 138.175 102.885 136.979 102.885C135.784 102.885 134.814 101.916 134.814 100.72",
    stroke: "#98A2B3",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.887 78.9143C148.172 78.5133 150.142 76.9413 150.598 75.25C151.012 76.7451 152.746 78.5133 154.31 78.6471C152.549 79.2706 150.866 81.1229 150.598 82.5781C150.417 81.0949 148.088 79.1305 146.887 78.9143Z",
    fill: "#98A2B3"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9434 97.8866C15.5863 97.6861 16.571 96.9004 16.799 96.0547C17.0058 96.8018 17.8725 97.6861 18.6546 97.7532C17.7744 98.0646 16.9328 98.9909 16.799 99.7185C16.7081 98.9769 15.5438 97.9945 14.9434 97.8866Z",
    fill: "#98A2B3"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8728 28.3118C26.8728 29.2395 26.1212 29.9908 25.1942 29.9908C24.2668 29.9908 23.5156 29.2395 23.5156 28.3118C23.5156 27.3846 24.2668 26.6328 25.1942 26.6328C26.1212 26.6328 26.8728 27.3846 26.8728 28.3118Z",
    fill: "#D1D8DF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.963 32.8141C138.963 34.364 137.707 35.6204 136.158 35.6204C134.608 35.6204 133.352 34.364 133.352 32.8141C133.352 31.2642 134.608 30.0078 136.158 30.0078C137.707 30.0078 138.963 31.2642 138.963 32.8141Z",
    fill: "#D2D8DF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.243 129.185C58.243 129.96 57.615 130.588 56.8401 130.588C56.0655 130.588 55.4375 129.96 55.4375 129.185C55.4375 128.409 56.0655 127.781 56.8401 127.781C57.615 127.781 58.243 128.409 58.243 129.185Z",
    stroke: "#98A2B3",
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.4099 17.5228C57.4099 18.4504 56.6583 19.2018 55.7313 19.2018C54.8043 19.2018 54.0527 18.4504 54.0527 17.5228C54.0527 16.5955 54.8043 15.8438 55.7313 15.8438C56.6583 15.8438 57.4099 16.5955 57.4099 17.5228Z",
    stroke: "#98A2B3",
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.228 144.725C99.1551 145.133 97.9546 144.594 97.5466 143.521C97.1385 142.448 97.6769 141.247 98.75 140.84C99.8222 140.431 101.023 140.97 101.431 142.043C101.839 143.116 101.3 144.317 100.228 144.725Z",
    stroke: "#98A2B3",
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1302 88.3311L96.707 89.7987L98.2044 87.239L117.5 54.2539V114.183H14.1152V22.887H19.0537V87.6701V98.7669L24.645 89.1817L53.2239 40.1894L86.1896 59.1363L88.7702 60.6195L90.2736 58.0507L111.964 20.9916L116.216 23.4211L90.6389 67.1636L57.6113 48.3607L55.0335 46.8931L53.5369 49.4541L21.159 104.859L18.5213 109.373H23.7492H36.1096H37.8265L38.6962 107.892L61.2068 69.5798L94.1302 88.3311Z",
    fill: "#F1F2F7",
    stroke: "#EAECF0",
    strokeWidth: 6
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.77 104.326C128.424 109.671 120.149 110.274 114.141 106.147C113.373 105.61 112.642 105.007 111.961 104.326C111.61 103.976 111.279 103.616 110.968 103.236C110.344 102.477 109.798 101.668 109.351 100.832C108.563 99.4197 108.027 97.9213 107.735 96.3726C106.791 91.5155 108.202 86.2874 111.961 82.5309C115.728 78.7631 120.957 77.3611 125.815 78.2958C127.363 78.5973 128.862 79.1329 130.275 79.9118C131.112 80.3691 131.91 80.9148 132.67 81.538C133.049 81.8484 133.41 82.1801 133.76 82.5309C134.442 83.2123 135.054 83.9418 135.581 84.7106C139.709 90.7164 139.105 98.9916 133.77 104.326Z",
    fill: "white",
    fillOpacity: 0.1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.276 103.279C126.714 108.841 117.702 108.84 112.14 103.279C106.585 97.7235 106.585 88.71 112.147 83.1487C117.702 77.5936 126.714 77.5936 132.27 83.1487C137.831 88.71 137.831 97.7235 132.276 103.279ZM135.13 80.2835C127.992 73.1451 116.424 73.1451 109.286 80.2835C102.148 87.4208 102.142 98.9956 109.28 106.134C115.776 112.629 125.959 113.214 133.121 107.882C133.821 107.36 134.495 106.776 135.137 106.134C135.779 105.491 136.364 104.818 136.884 104.118C142.217 96.9548 141.626 86.7792 135.13 80.2835Z",
    fill: "#E0E2EE"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.224 133.043L162.924 133.343C160.941 135.327 157.695 135.327 155.711 133.343L137.404 115.036L144.917 107.523L163.224 125.83C165.208 127.814 165.208 131.06 163.224 133.043Z",
    fill: "url(#paint0_linear_4723_28494)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.279 103.547L142.689 108.957L138.848 112.796L133.439 107.386C134.153 106.854 134.84 106.258 135.496 105.603C136.151 104.948 136.748 104.261 137.279 103.547Z",
    fill: "#E0E2EE"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.947 125.603L155.483 133.067L154.139 131.722L161.603 124.258L162.947 125.603Z",
    fill: "#EF545F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.33 107.772L137.661 115.442L136.521 114.302L144.191 106.633L145.33 107.772Z",
    fill: "url(#paint1_linear_4723_28494)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.592 81.2263L109.784 100.034C109.076 98.7642 108.594 97.4172 108.332 96.0248L124.583 79.7734C125.975 80.0455 127.323 80.5261 128.592 81.2263Z",
    fill: "#F8F8F8",
    fillOpacity: 0.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.761 85.6917L114.427 104.874C113.699 104.394 113.006 103.855 112.36 103.245C112.027 102.931 111.712 102.609 111.418 102.269L132 82.8516C132.36 83.1304 132.702 83.4272 133.034 83.7411C133.68 84.3509 134.262 85.0037 134.761 85.6917Z",
    fill: "#F8F8F8",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4723_28494",
    x1: 151.058,
    y1: 93.8698,
    x2: 123.751,
    y2: 121.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4723_28494",
    x1: 140.926,
    y1: 102.228,
    x2: 132.117,
    y2: 111.037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF404E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeMissing);
export default __webpack_public_path__ + "static/media/TypeMissing.ed42b93901a06dd6f97aca1748438f89.svg";
export { ForwardRef as ReactComponent };